'use strict';
const dates = ['dateOfBirth', 'identificationExpirationDate'];
const avoidFields = ['password', 'frequentFlyerCompanyName', 'cvv2', 'travellerId', 'saveCardData', 'travellerType',
    'paymentType', 'loginPassword'];
let restoring = false;
const fillValues = function($input, value, dataName) {
    if (value) {
        if ($input.attr('type') === 'radio') {
            $input.prop('checked', $input.val() === value);
        } else {
            $input.val(value);
        }
        if (dataName === 'ccnumber') {
            $input.trigger(Odigeo.Events.input);
        }
        $input.trigger(Odigeo.Events.blur).trigger(Odigeo.Events.change);
        if (Odigeo._.indexOf(dates, dataName) > -1 && !!Odigeo.UIElements.enhanceDateWithSelects) {
            Odigeo.AB.isCobaltDesktopForms
                ? Odigeo.UIElements.enhanceDateWithSelects.setCobaltDate($input, value)
                : Odigeo.UIElements.enhanceDateWithSelects.setDate($input, value);
        }
    }
};

const getInputProps = ($input) => ({
    $input: $input,
    dataName: $input.prop('name') || $input.data('name'),
    value: $input.val(),
    isRadio: $input.attr('type') === 'radio',
});

const handleLegacyField = (handleField, data, inputProps) => {
    const {$input, dataName} = inputProps;
    if (dataName && Odigeo._.indexOf(avoidFields, dataName) === -1 &&
        (Odigeo._.size($input.parents('.hidden')) + Odigeo._.size($input.parents('[data-status="hidden"]'))) === 0) {
        handleField(data, inputProps);
    }
};

const restoreField = (data, {$input, dataName, value, isRadio}) => {
    if (value === data[dataName] || !isRadio) {
        fillValues($input, data[dataName], dataName);
    }
};

const saveField = (data, {$input, dataName, value, isRadio}) => {
    if (($input.prop('checked') || !isRadio) && value && value !== '-1') {
        data[dataName] = value;
    }
};

class LegacyField {
    constructor($input) {
        this.inputProps = getInputProps($input);
    }
    save(pageData) {
        handleLegacyField(saveField, pageData, this.inputProps);
    }
    fetch(pageData) {
        handleLegacyField(restoreField, pageData, this.inputProps);
    }
}

const buildField = (field) => {
    if (Odigeo._.isFunction(field.save)) {
        return field;
    }
    return new LegacyField($(field));
};

const restoreData = (fields, data) => {
    restoring = true;
    Odigeo._.each(fields, (field) => buildField(field).fetch(data));
    restoring = false;
};

const saveData = (fields, data) => {
    restoring = false;
    Odigeo._.each(fields, (field) => buildField(field).save(data));
};

var _clickCheckBoxes = function(selectCheckBoxes, passengersData, name) {
    Odigeo._.each(selectCheckBoxes, function(request, key) {
        if (!!passengersData[name][key] && !request.is(':checked')) {
            request.click();
        }
    });
};
var _getStorageData = function(pageData) {
    var data = Odigeo.Utils.parseJson(Odigeo.Session.get(pageData));
    data = !data ? Odigeo.Utils.parseJson(Odigeo.Storage.get(pageData)) : data;
    return data;
};

module.exports = {
    check: function(pageData) {
        return !!_getStorageData(pageData);
    },
    get: function(pageData, element) {
        var data = _getStorageData(pageData);
        return Odigeo._.isObject(data) && data[element] ? data[element] : undefined;
    },
    restore: function(pageData, fields, name, selectCheckBoxes) {
        var data = Odigeo.Utils.parseJson(Odigeo.Session.get(pageData));
        data = (!data || !data[name]) ? Odigeo.Utils.parseJson(Odigeo.Storage.get(pageData)) : data;

        if (data && data[name]) {
            if (!Odigeo._.isEmpty(selectCheckBoxes)) {
                _clickCheckBoxes(selectCheckBoxes, data, name);
            }
            restoreData(fields, data[name]);
        }
    },
    save: function(localStorageEnabled, pageData, fields, name, otherValues) {
        if (!restoring) {
            var elementData = Odigeo._.extend({}, otherValues);
            var data = Odigeo.Utils.parseJson(Odigeo.Session.get(pageData)) || {};

            saveData(fields, elementData);

            data[name] = Odigeo._.extend(data[name] || {}, elementData);

            Odigeo.Session.set(pageData, JSON.stringify(data));

            if (localStorageEnabled) {
                Odigeo.Storage.set(pageData, JSON.stringify(data));
            }
        }
    },
    removeStorageOnNotSelected: function($element, pageData) {
        $element.on(Odigeo.Events.change, function() {
            if (!$element.prop('checked')) {
                Odigeo.Storage.remove(pageData);
            }
        });
    },
    removeStorageOff: function($element) {
        $element.off(Odigeo.Events.change);
    },
};
